























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Step } from '@/interfaces/Step';

@Component({})
export default class ListItemStep extends Vue {
  @Prop()
  step!: Step;

  @Prop()
  overwriteStep?: Step;

  @Prop()
  crossOut?: boolean;

  @Prop()
  crossOutReason?: string;

  get startDateString() {
    let string = '';
    const planned_startdate = this.overwriteStep?.planned_startdate
      ? this.overwriteStep?.planned_startdate
      : this.step?.planned_startdate;
    if (planned_startdate) string += `${planned_startdate}`;

    return string;
  }

  get startTimeString() {
    let string = '';
    const planned_start = this.overwriteStep?.planned_start
      ? this.overwriteStep?.planned_start
      : this.step?.planned_start;

    if (planned_start) string += `${planned_start}`;

    return string;
  }

  get endDateString() {
    let string = '';
    const planned_enddate = this.overwriteStep?.planned_enddate
      ? this.overwriteStep?.planned_enddate
      : this.step?.planned_enddate;
    if (planned_enddate) string += `${planned_enddate}`;

    return string;
  }

  get endTimeString() {
    let string = '';
    const planned_end = this.overwriteStep?.planned_end
      ? this.overwriteStep?.planned_end
      : this.step?.planned_end;

    if (planned_end) string += `${planned_end}`;

    return string;
  }

  get stepName() {
    let name = '';
    const stepLanguage =
      this.step.stepLanguages.find(
        (sL: any) => sL.languageId === this.$store.state.user.languageId
      ) || this.step.stepLanguages[0];
    if (stepLanguage) name = stepLanguage.name;
    if (this.overwriteStep) {
      const overwriteStepLangauge = this.step.stepLanguages.find(
        (sL: any) => sL.languageId === this.$store.state.user.languageId
      );
      if (overwriteStepLangauge) name = overwriteStepLangauge.name;
    }
    return name;
  }
}
